export default "__VITE_ASSET__cbe8b962__"